<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!--
    Portrait kiosk shell for the 42" panel. Build kiosk pages against a
    portrait canvas; this surface renders at native scale (no desktop
    auto-zoom). No navigation chrome by design.
-->
<!-- Temporary page switcher (top corner) so staff can flip between Pricing,
     Packages, and Schedule. Hidden for Printer kiosks — those are
     single-purpose Schedule stations. TikTok stays Admin-only. -->
@if (!isScheduleStation) {
<div class="kiosk-switch">
    <a
        class="kiosk-switch__btn"
        routerLink="/kiosk/pricing"
        routerLinkActive="kiosk-switch__btn--active"
    >
        <mat-icon>sell</mat-icon>
        <span>Pricing</span>
    </a>
    <a
        class="kiosk-switch__btn"
        routerLink="/kiosk/packages"
        routerLinkActive="kiosk-switch__btn--active"
    >
        <mat-icon>inventory_2</mat-icon>
        <span>Packages</span>
    </a>
    <a
        class="kiosk-switch__btn"
        routerLink="/kiosk/receiving"
        routerLinkActive="kiosk-switch__btn--active"
    >
        <mat-icon>photo_camera</mat-icon>
        <span>Receiving</span>
    </a>
    <a
        class="kiosk-switch__btn"
        routerLink="/kiosk/schedule"
        routerLinkActive="kiosk-switch__btn--active"
    >
        <mat-icon>calendar_view_week</mat-icon>
        <span>Schedule</span>
    </a>
    @if (showCartsNav) {
    <a
        class="kiosk-switch__btn"
        routerLink="/kiosk/carts"
        routerLinkActive="kiosk-switch__btn--active"
    >
        <mat-icon>shopping_cart</mat-icon>
        <span>Carts</span>
    </a>
    }
    @if (isCartsPage) {
    <span class="kiosk-switch__sep"></span>
    <button
        type="button"
        class="kiosk-switch__btn kiosk-switch__btn--language"
        [class.kiosk-switch__btn--language-active]="lang === 'en'"
        (click)="setLang('en')"
    >
        EN
    </button>
    <button
        type="button"
        class="kiosk-switch__btn kiosk-switch__btn--language"
        [class.kiosk-switch__btn--language-active]="lang === 'es'"
        (click)="setLang('es')"
    >
        ES
    </button>
    }
    @if (showTikTokNav) {
    <a
        class="kiosk-switch__btn"
        routerLink="/kiosk/tiktok"
        routerLinkActive="kiosk-switch__btn--active"
    >
        <mat-icon>videocam</mat-icon>
        <span>TikTok</span>
    </a>
    }
    @if (agentAvailable) {
    <button
        type="button"
        class="kiosk-switch__btn kiosk-switch__btn--assistant"
        [class.kiosk-switch__btn--assistant-on]="agent?.isRunning"
        (click)="toggleAgent()"
    >
        <mat-icon>{{ agent?.isRunning ? 'graphic_eq' : 'auto_awesome' }}</mat-icon>
        <span>Assistant</span>
    </button>
    <!-- Engine picker hidden for launch — Gemini 3.1 is the default. The legacy
         Gemini and Grok engines will be revisited later. -->
    }
    <span class="kiosk-switch__sep"></span>
    <button
        type="button"
        class="kiosk-switch__btn kiosk-switch__btn--logout"
        (click)="signOut()"
    >
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
    </button>
</div>
}

<!-- Printer Schedule stations hide the switcher, but still need a way to
     end the session — a standalone logout button. -->
@if (isScheduleStation) {
<div class="kiosk-switch kiosk-switch--solo">
    <button
        type="button"
        class="kiosk-switch__btn kiosk-switch__btn--logout"
        (click)="signOut()"
    >
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
    </button>
</div>
}

<div class="kiosk-shell">
    <!-- *ngIf="true" hack keeps router-outlet swapping correctly on layout
         changes (mirrors the empty layout). -->
    @if (true) {
        <router-outlet></router-outlet>
    }
</div>

<!-- Voice-only assistant overlay (hands-free). Toggled from the top bar on
     agent-enabled kiosk pages (Packages). -->
<kiosk-agent></kiosk-agent>

<!-- Idle "attract" screensaver. Covers the whole panel after a stretch of no
     interaction so a passer-by always sees what the kiosk does; the first tap
     dismisses it and starts a fresh quote. -->
@if (screensaverActive) {
    <kiosk-screensaver
        [pageLabel]="ssPageLabel"
        [pageTagline]="ssPageTagline"
        [showImagery]="ssShowImagery"
        (wake)="onScreensaverWake()"
    ></kiosk-screensaver>
}
